// components/common/EmptyState.jsx
import React from "react";
import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/Card";

const EmptyState = ({
  message = "No hay datos disponibles",
  icon: Icon = AlertCircle,
  action,
}) => {
  return (
    <Card className="w-full bg-orange-50 border-orange-200">
      <CardContent className="flex flex-col items-center justify-center py-8">
        <Icon className="h-12 w-12 text-orange-500 mb-4" />
        <p className="text-gray-600 text-center mb-4">{message}</p>
        {action && <div className="mt-2">{action}</div>}
      </CardContent>
    </Card>
  );
};

export default EmptyState;
